<template>
  <div class="text-end">
    <div class="dropdown">
      <button
        class="btn btn-outline-dark btn-sm"
        type="button"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i v-if="isSubscribedToCurrentTopic" key="1" class="fas fa-bell"></i>
        <i v-else key="2" class="far fa-bell"></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        <li><a @click.prevent="notificationsOn" class="dropdown-item small fw-semibold" href="#"><i class="fas fa-bell me-2"></i> {{'Email notifications' | translate}}</a></li>
        <li><a @click.prevent="notificationsOff" class="dropdown-item small fw-semibold" href="#"><i class="far fa-bell me-2"></i> {{'In app notifications' | translate}}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['topic'],
  methods: {
    notificationsOn() {
        axios.post('/json/email-notification', {
          topic: this.topic,
          action: true,
        })
        .then(({data}) => {
            this.$store.commit('setEmailNotification', data)
        })
    },
    notificationsOff() {
      axios.post('/json/email-notification', {
        topic: this.topic,
          action: false,
        })
        .then(({data}) => {
          this.$store.commit('setEmailNotification', data)
        })

    },
  },
  computed: {
      communityNotifications() {
          return _.get(this.$store.state, 'user.email_notification', {})
      },
      subscribedTopics() {
        return _.get(this.communityNotifications, 'community_topics', [])
      },
      isSubscribedToCurrentTopic() {
        if (this.topic) {
          return _.get(this.subscribedTopics, this.topic, false)
        }
        return _.get(this.subscribedTopics, 0, false)
      },
  },
}
</script>

